<div class="border rounded-xl border-border-secondary p-4 flex flex-col md:flex-row items-center gap-4 md:gap-2">
  <div class="flex items-center gap-4 flex-1 w-full">
    <div>
      <sbnb-profile-img [src]="cleaner().avatar" [alt]="cleaner().name + ' profile image'" />
    </div>
    <div class="flex-1 flex flex-col gap-1">
      <strong>{{ cleaner().name }}</strong>
      <div class="flex flex-wrap items-center gap-2 text-text-tertiary text-sm md:text-base">
        @if (cleaner().stars) {
          <div>{{ cleaner().stars }} ⭐</div>
        }
        @if (cleaner().stars && cleaner().completed_tasks) {
          <ui-divider-dot class="hidden sm:block" />
        }
        @if (cleaner().completed_tasks) {
          <div>{{ cleaner().completed_tasks }} Cleans</div>
        }
        @if ((cleaner().stars || cleaner().completed_tasks) && cleaner().joined) {
          <ui-divider-dot class="hidden sm:block" />
        }
        @if (cleaner().joined) {
          <div>Joined {{ cleaner().joined | timeAgo }}</div>
        }
      </div>
    </div>
  </div>

  @if (showMessageButton()) {
    @if (hasMessages()) {
      <ui-button
        class="flex-shrink-0 w-full md:w-auto"
        size="lg"
        variant="secondary"
        [label]="unreadMessagesCount() + ' unread ' + ('messages' | pluralize: unreadMessagesCount())"
        (onClick)="onMessageClick()" />
    } @else {
      <ui-button
        class="flex-shrink-0 w-full md:w-auto"
        size="lg"
        variant="tertiary"
        label="Send message"
        (onClick)="onMessageClick()" />
    }
  }
</div>
